/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air ChFAR
 * Endpoints to provide ChFAR offers  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid` * `b2bportal.reshop.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.reshop.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.trip_details.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.trip_details.success`   * tags: `api_version`, `product`, `tenantid`   # Tracking Error Codes * `already_exercised` * `bad_request` * `contract_not_found` * `discount_failure` * `expired` * `flight_cancellation_failed` * `flight_in_void_window` * `flight_shop_failure` * `internal_error` * `no_availability` * `not_enough_seats` * `not_found` * `offer_not_found` * `product_not_found` * `request_deserialization_error` * `response_serialization_error` * `trip_details_failure` * `unknown`
 *
 * The version of the OpenAPI document: v3p69
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
export interface Air {
    'Funnel': FunnelEnum;
}


/**
 * Details on a AirChFAR discount applied to a flight
 * @export
 * @interface AirChfarDiscount
 */
export interface AirChfarDiscount {
    'contractId': string;
    'totalDiscountAmount': Prices;
}
/**
 * @type AirChfarError
 * @export
 */
export type AirChfarError = { AirChfarError: 'AirChfarErrorCode' } & AirChfarErrorCode | { AirChfarError: 'DiscountFailure' } & DiscountFailure | { AirChfarError: 'NotEnoughSeats' } & NotEnoughSeats | { AirChfarError: 'OfferNotFound' } & OfferNotFound | { AirChfarError: 'ProductNotFound' } & ProductNotFound;

export interface AirChfarErrorCode {
    'code': string;
    'message'?: string;
    'AirChfarError': AirChfarErrorEnum;
}


export const AirChfarErrorEnum = {
    AirChfarErrorCode: 'AirChfarErrorCode',
    DiscountFailure: 'DiscountFailure',
    NotEnoughSeats: 'NotEnoughSeats',
    OfferNotFound: 'OfferNotFound',
    ProductNotFound: 'ProductNotFound'
} as const;

export type AirChfarErrorEnum = typeof AirChfarErrorEnum[keyof typeof AirChfarErrorEnum];


export interface AirChfarExerciseDiscountUpdate {
    'contractId': string;
}
export interface AirChfarExerciseQuoteRequest {
    'itineraryId': string;
    'contractId': string;
    'singleItineraryRequest': SingleFlightItineraryRequest;
}
/**
 * @type AirChfarExerciseQuoteResponse
 * @export
 */
export type AirChfarExerciseQuoteResponse = { AirChfarExerciseQuoteResponse: 'ExerciseAvailable' } & AirChfarExerciseQuoteResponseExerciseAvailable | { AirChfarExerciseQuoteResponse: 'NotAvailable' } & AirChfarExerciseQuoteResponseNotAvailable;

export const AirChfarExerciseQuoteResponseEnum = {
    ExerciseAvailable: 'ExerciseAvailable',
    NotAvailable: 'NotAvailable'
} as const;

export type AirChfarExerciseQuoteResponseEnum = typeof AirChfarExerciseQuoteResponseEnum[keyof typeof AirChfarExerciseQuoteResponseEnum];


export interface AirChfarExerciseQuoteResponseExerciseAvailable {
    'itineraryResponse': SingleFlightItineraryResponse;
    'coverage': Prices;
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
}


/**
 * @type AirChfarExerciseQuoteResponseNotAvailable
 * @export
 */
export type AirChfarExerciseQuoteResponseNotAvailable = { NotAvailable: 'ContractExercised' } & AirChfarExerciseQuoteResponseNotAvailableContractExercised | { NotAvailable: 'ContractExpired' } & AirChfarExerciseQuoteResponseNotAvailableContractExpired | { NotAvailable: 'ContractNotFound' } & AirChfarExerciseQuoteResponseNotAvailableContractNotFound | { NotAvailable: 'ContractRemoved' } & AirChfarExerciseQuoteResponseNotAvailableContractRemoved | { NotAvailable: 'FlightInVoidWindow' } & AirChfarExerciseQuoteResponseNotAvailableFlightInVoidWindow | { NotAvailable: 'Unknown' } & AirChfarExerciseQuoteResponseNotAvailableUnknown;

export interface AirChfarExerciseQuoteResponseNotAvailableContractExercised {
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


export interface AirChfarExerciseQuoteResponseNotAvailableContractExpired {
    'expiredAt': string;
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


export interface AirChfarExerciseQuoteResponseNotAvailableContractNotFound {
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


export interface AirChfarExerciseQuoteResponseNotAvailableContractRemoved {
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


export const AirChfarExerciseQuoteResponseNotAvailableEnum = {
    ContractExercised: 'ContractExercised',
    ContractExpired: 'ContractExpired',
    ContractNotFound: 'ContractNotFound',
    ContractRemoved: 'ContractRemoved',
    FlightInVoidWindow: 'FlightInVoidWindow',
    Unknown: 'Unknown'
} as const;

export type AirChfarExerciseQuoteResponseNotAvailableEnum = typeof AirChfarExerciseQuoteResponseNotAvailableEnum[keyof typeof AirChfarExerciseQuoteResponseNotAvailableEnum];


export interface AirChfarExerciseQuoteResponseNotAvailableFlightInVoidWindow {
    'trackingProperties': TrackingProperties;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


export interface AirChfarExerciseQuoteResponseNotAvailableUnknown {
    'message'?: string;
    'AirChfarExerciseQuoteResponse': AirChfarExerciseQuoteResponseEnum;
    'NotAvailable': AirChfarExerciseQuoteResponseNotAvailableEnum;
}


/**
 * During the air ChFAR exercise process, shared models defined in b2b-interfaces air are used to call flights shop APIs

* `ChfarExerciseItinerary` - Maps to com.hopper.b2b.air.booking.model.itinerary.ChfarExerciseItinerary
* `ShopSummaryRequest` - Maps to com.hopper.b2b.air.shopping.model.shopSummary.ShopSummaryRequest
* `ShopSummaryResponse` - Maps to com.hopper.b2b.air.shopping.model.shopSummary.ShopSummaryResponseV2
 * @export
 * @enum {string}
 */

export const AirChfarExerciseSharedModels = {
    ChfarExerciseItinerary: 'ChfarExerciseItinerary',
    ShopSummaryRequest: 'ShopSummaryRequest',
    ShopSummaryResponse: 'ShopSummaryResponse'
} as const;

export type AirChfarExerciseSharedModels = typeof AirChfarExerciseSharedModels[keyof typeof AirChfarExerciseSharedModels];


/**
 * Model used to generify shared types across any product or payment type. The type of `OpaqueValue`
is a shared value between the FE and BFF. As a result each implementation of the purchase interface
can use different products/payments or even different versions of products or payments.
 * @export
 * @interface AirChfarExerciseSharedModelsOpaqueValue
 */
export interface AirChfarExerciseSharedModelsOpaqueValue {
    'type': AirChfarExerciseSharedModels;
    'value': any;
}


/**
 * `rebookingShopFilters` - Flights shopping request model, maps to com.hopper.b2b.air.shopping.model.shopSummary.ShopSummaryRequest
 * @export
 * @interface AirChfarExerciseShopRequest
 */
export interface AirChfarExerciseShopRequest {
    'itineraryId': string;
    'contractId': string;
    'rebookingShopFilters': AirChfarExerciseSharedModelsOpaqueValue;
}
/**
 * @type AirChfarExerciseShopResponse
 * @export
 */
export type AirChfarExerciseShopResponse = { AirChfarExerciseShopResponse: 'Failure' } & AirChfarExerciseShopResponseFailure | { AirChfarExerciseShopResponse: 'Success' } & AirChfarExerciseShopResponseSuccess;

export const AirChfarExerciseShopResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type AirChfarExerciseShopResponseEnum = typeof AirChfarExerciseShopResponseEnum[keyof typeof AirChfarExerciseShopResponseEnum];


/**
 * @type AirChfarExerciseShopResponseFailure
 * @export
 */
export type AirChfarExerciseShopResponseFailure = { Failure: 'AlreadyExercised' } & AirChfarExerciseShopResponseFailureAlreadyExercised | { Failure: 'ContractNotFound' } & AirChfarExerciseShopResponseFailureContractNotFound | { Failure: 'DiscountFailure' } & AirChfarExerciseShopResponseFailureDiscountFailure | { Failure: 'Expired' } & AirChfarExerciseShopResponseFailureExpired | { Failure: 'FlightShopFailure' } & AirChfarExerciseShopResponseFailureFlightShopFailure | { Failure: 'Unknown' } & AirChfarExerciseShopResponseFailureUnknown;

export interface AirChfarExerciseShopResponseFailureAlreadyExercised {
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


export interface AirChfarExerciseShopResponseFailureContractNotFound {
    'contractId': string;
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


export interface AirChfarExerciseShopResponseFailureDiscountFailure {
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


export const AirChfarExerciseShopResponseFailureEnum = {
    AlreadyExercised: 'AlreadyExercised',
    ContractNotFound: 'ContractNotFound',
    DiscountFailure: 'DiscountFailure',
    Expired: 'Expired',
    FlightShopFailure: 'FlightShopFailure',
    Unknown: 'Unknown'
} as const;

export type AirChfarExerciseShopResponseFailureEnum = typeof AirChfarExerciseShopResponseFailureEnum[keyof typeof AirChfarExerciseShopResponseFailureEnum];


export interface AirChfarExerciseShopResponseFailureExpired {
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


export interface AirChfarExerciseShopResponseFailureFlightShopFailure {
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


export interface AirChfarExerciseShopResponseFailureUnknown {
    'message'?: string;
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
    'Failure': AirChfarExerciseShopResponseFailureEnum;
}


/**
 * `value` - Flights shopping response, maps to com.hopper.b2b.air.shopping.model.shopSummary.ShopSummaryResponseV2
 * @export
 * @interface AirChfarExerciseShopResponseSuccess
 */
export interface AirChfarExerciseShopResponseSuccess {
    'value': AirChfarExerciseSharedModelsOpaqueValue;
    'fareIdToPriceDifference': { [key: string]: Prices; };
    'AirChfarExerciseShopResponse': AirChfarExerciseShopResponseEnum;
}


export interface AirChfarOffer {
    'trackingProperties': TrackingProperties;
    'quoteDecision': QuoteDecision;
    'coverageAmount': Prices;
    'premiumAmount': Prices;
    'coveragePercentage': string;
    'title': string;
    'quoteId': string;
}


/**
 * `coveragePercentage` - coveragePercentage values between 0 and 100
 * @export
 * @interface AirChfarOfferV1
 */
export interface AirChfarOfferV1 {
    'quoteId': string;
    'premiumAmount': Prices;
    'coverageAmount': Prices;
    'coveragePercentage': Percentage;
}
/**
 * Air ChFAR quote that is passed opaquely to the frontend in the Purchase API quote
 * @export
 * @interface AirChfarPriceQuoteData
 */
export interface AirChfarPriceQuoteData {
    'totalPremiumAmount': Prices;
    'perPaxPremiumAmount': Prices;
    'totalCoverageAmount': Prices;
    'trackingProperties': TrackingProperties;
    'coveragePercentage': string;
    'perPaxCoverageAmount': Prices;
    'currencyCode': string;
    'quoteId': string;
}
export interface AirChfarSchedulePriceQuoteRequest {
    'chfarQuoteId': string;
    'tripId': string;
    'seatedPaxCount': number;
}
/**
 * ChFAR - request to shop a ChFAR contract
 * @export
 * @interface AirChfarShopRequest
 */
export interface AirChfarShopRequest {
    'contractId': string;
    'rebookingShopFilters': ShopSummaryRequest;
}
/**
 * @type AirChfarShopResponse
 * ChFAR - shop response
 * @export
 */
export type AirChfarShopResponse = { AirChfarShopResponse: 'Failure' } & AirChfarShopResponseFailure | { AirChfarShopResponse: 'Success' } & Success;

export interface AirChfarShopResponseAlreadyExercised {
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


export interface AirChfarShopResponseContractNotFound {
    'contractId': string;
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


export interface AirChfarShopResponseDiscountFailure {
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


export const AirChfarShopResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type AirChfarShopResponseEnum = typeof AirChfarShopResponseEnum[keyof typeof AirChfarShopResponseEnum];


export interface AirChfarShopResponseExpired {
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


/**
 * @type AirChfarShopResponseFailure
 * @export
 */
export type AirChfarShopResponseFailure = { Failure: 'AlreadyExercised' } & AirChfarShopResponseAlreadyExercised | { Failure: 'ContractNotFound' } & AirChfarShopResponseContractNotFound | { Failure: 'DiscountFailure' } & AirChfarShopResponseDiscountFailure | { Failure: 'Expired' } & AirChfarShopResponseExpired | { Failure: 'FlightShopFailure' } & AirChfarShopResponseFlightShopFailure | { Failure: 'Unknown' } & AirChfarShopResponseUnknown;

export const AirChfarShopResponseFailureEnum = {
    AlreadyExercised: 'AlreadyExercised',
    ContractNotFound: 'ContractNotFound',
    DiscountFailure: 'DiscountFailure',
    Expired: 'Expired',
    FlightShopFailure: 'FlightShopFailure',
    Unknown: 'Unknown'
} as const;

export type AirChfarShopResponseFailureEnum = typeof AirChfarShopResponseFailureEnum[keyof typeof AirChfarShopResponseFailureEnum];


export interface AirChfarShopResponseFlightShopFailure {
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


export interface AirChfarShopResponseUnknown {
    'message': string;
    'Failure': AirChfarShopResponseFailureEnum;
    'AirChfarShopResponse': AirChfarShopResponseEnum;
}


/**
 * ChFAR - request for trip details against a ChFAR contract and tripId
 * @export
 * @interface AirChfarTripDetailsRequest
 */
export interface AirChfarTripDetailsRequest {
    'contractId': string;
    'tripId': TripId;
}
/**
 * @type AirChfarTripDetailsResponse
 * ChFAR - Trip Details response
 * @export
 */
export type AirChfarTripDetailsResponse = { AirChfarTripDetailsResponse: 'Failure' } & AirChfarTripDetailsResponseFailure | { AirChfarTripDetailsResponse: 'Success' } & Success;

export interface AirChfarTripDetailsResponseAlreadyExercised {
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export interface AirChfarTripDetailsResponseContractNotFound {
    'contractId': string;
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export interface AirChfarTripDetailsResponseDiscountFailure {
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export const AirChfarTripDetailsResponseEnum = {
    Failure: 'Failure',
    Success: 'Success'
} as const;

export type AirChfarTripDetailsResponseEnum = typeof AirChfarTripDetailsResponseEnum[keyof typeof AirChfarTripDetailsResponseEnum];


export interface AirChfarTripDetailsResponseExpired {
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


/**
 * @type AirChfarTripDetailsResponseFailure
 * @export
 */
export type AirChfarTripDetailsResponseFailure = { Failure: 'AlreadyExercised' } & AirChfarTripDetailsResponseAlreadyExercised | { Failure: 'ContractNotFound' } & AirChfarTripDetailsResponseContractNotFound | { Failure: 'DiscountFailure' } & AirChfarTripDetailsResponseDiscountFailure | { Failure: 'Expired' } & AirChfarTripDetailsResponseExpired | { Failure: 'TripDetailsFailure' } & AirChfarTripDetailsResponseTripDetailsFailure | { Failure: 'Unknown' } & AirChfarTripDetailsResponseUnknown;

export const AirChfarTripDetailsResponseFailureEnum = {
    AlreadyExercised: 'AlreadyExercised',
    ContractNotFound: 'ContractNotFound',
    DiscountFailure: 'DiscountFailure',
    Expired: 'Expired',
    TripDetailsFailure: 'TripDetailsFailure',
    Unknown: 'Unknown'
} as const;

export type AirChfarTripDetailsResponseFailureEnum = typeof AirChfarTripDetailsResponseFailureEnum[keyof typeof AirChfarTripDetailsResponseFailureEnum];


export interface AirChfarTripDetailsResponseTripDetailsFailure {
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export interface AirChfarTripDetailsResponseUnknown {
    'message': string;
    'Failure': AirChfarTripDetailsResponseFailureEnum;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export interface Aircraft {
    'info': AmenityInfo;
}
export interface Airline {
    'displayName': string;
    'customHashTag'?: string;
    'fullName': string;
    'isLcc': boolean;
    'webLinks': WebLinks;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Airline
     */
    'code': string;
    'cabinClassMappings': { [key: string]: HopperCabinClass; };
    'phone'?: string;
}
/**
 * `cityName` - The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
 * `servedCity` - IATA has a concept of "served metropolitan area";
   e.g. Newark Intl Airport (EWR) is geographically in Newark but "serves" NYC
   This is a good presumed destination (for example for hotels or whatever)
   It is not however an acceptable display name for the airport (So we should not display EWR as "New York (EWR)")
 * `military` - military airports often place restrictions on international travelers
 * @export
 * @interface Airport
 */
export interface Airport {
    'coordinates': Coordinates;
    'servedCityName': string;
    'name': string;
    /**
     * The name of the metropolitan area generally associated with the airport
   e.g. the YUL airport is in Dorval but should have cityName == "Montreal"
   e.g. the EWL airport serves New York City but it's still treated as belonging to Newark, so cityName == "Newark"
     * @type {string}
     * @memberof Airport
     */
    'cityName': string;
    /**
     * 3 character IATA city code
     * @type {string}
     * @memberof Airport
     */
    'servedCity': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Airport
     */
    'code': string;
    'geography': GeopoliticalInfo;
    /**
     * military airports often place restrictions on international travelers
     * @type {boolean}
     * @memberof Airport
     */
    'military': boolean;
}
/**
 * When regionType is airport, code represents an IATA airport code and when regionType is city, code is an IATA city code
 * @export
 * @interface AirportRegion
 */
export interface AirportRegion {
    'regionType': RegionType;
    'code': string;
}


export interface Allowed {
    'allowance': BaggageAllowance;
    'charges': Array<BaggageCharge>;
    'BaggageInfo': BaggageInfoEnum;
}


export interface AmadeusBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface Amenities {
    'seat': Seat;
    'aircraft': Aircraft;
    'entertainment': Entertainment;
    'beverage': Beverage;
    'wifi': Wifi;
    'layout': Layout;
    'power': Power;
    'freshFood': FreshFood;
}
export interface AmenitiesAndUtasPerSlice {
    'amenitiesAndUtas': Array<AmenitiesAndUtasV2>;
}
export interface AmenitiesAndUtasV2 {
    'amenities'?: Amenities;
    'utas': UtasV2;
    'upas': Array<Upa>;
}
export interface AmenitiesFare {
    'brandName': string;
    'brandCodes': Array<string>;
}
export const AmenityExists = {
    na: 'na',
    no: 'no',
    yes: 'yes'
} as const;

export type AmenityExists = typeof AmenityExists[keyof typeof AmenityExists];


export interface AmenityInfo {
    'displayText'?: string;
    'quality': AmenityQuality;
    'updatedAt'?: string;
}


export const AmenityQuality = {
    better: 'better',
    na: 'na',
    standard: 'standard'
} as const;

export type AmenityQuality = typeof AmenityQuality[keyof typeof AmenityQuality];


/**
 * A monetary amount
 * @export
 * @interface Amount
 */
export interface Amount {
    'amount': number;
    'currency': string;
}
export const AssessmentV2 = {
    Benefit: 'Benefit',
    Fee: 'Fee',
    Neutral: 'Neutral',
    Restriction: 'Restriction'
} as const;

export type AssessmentV2 = typeof AssessmentV2[keyof typeof AssessmentV2];


export interface Available {
    'offers': Array<AirChfarOffer>;
    'GetAirChfarOfferResponse': GetAirChfarOfferResponseEnum;
}


export interface BagLimits {
    'weightKg'?: string;
    'sizeLcm'?: string;
}
export interface BaggageAllowance {
    'pieces': number;
    'descriptions': Array<string>;
    'maximumMass'?: Mass;
}
export interface BaggageCharge {
    'firstPiece': number;
    'amount': number;
    'maximumMass'?: Mass;
    'lastPiece': number;
    'currency': string;
    'descriptions': Array<string>;
}
/**
 * @type BaggageInfo
 * @export
 */
export type BaggageInfo = { BaggageInfo: 'Allowed' } & Allowed | { BaggageInfo: 'NotAllowed' } & NotAllowed | { BaggageInfo: 'Unknown' } & Unknown;

export const BaggageInfoEnum = {
    Allowed: 'Allowed',
    NotAllowed: 'NotAllowed',
    Unknown: 'Unknown'
} as const;

export type BaggageInfoEnum = typeof BaggageInfoEnum[keyof typeof BaggageInfoEnum];


export interface Beverage {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


export interface ChFarOfferNotFound {
    'GetAirChfarOfferResponse': GetAirChfarOfferResponseEnum;
}


export interface Coordinates {
    'lat': number;
    'lon': number;
}
export interface CorporateTravel {
    'policyCompliance': PolicyCompliance;
}
export interface Cta {
    'text': string;
    'url': string;
}
export const Dealness = {
    fair: 'fair',
    good: 'good',
    great: 'great',
    wait: 'wait'
} as const;

export type Dealness = typeof Dealness[keyof typeof Dealness];


export interface DiscountFailure {
    'message'?: string;
    'AirChfarError': AirChfarErrorEnum;
}


/**
 * A displayable monetary amount
 * @export
 * @interface DisplayAmount
 */
export interface DisplayAmount {
    'amount': Amount;
    'display': string;
}
export interface Entertainment {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this outbound.
 * @export
 * @interface Example
 */
export interface Example {
    'trip': string;
    'fare': string;
}
/**
 * `return` - pointer to second leg of fare (can be shared with other Fare)
 * `amount` - price of the fare; will be empty for Southwest
 * `id` - unique ID
 * `outbound` - pointer to first leg of fare (can be shared with other Fare)
 * @export
 * @interface Fare
 */
export interface Fare {
    /**
     * pointer to second leg of fare (can be shared with other Fare)
     * @type {string}
     * @memberof Fare
     */
    'return'?: string;
    'tripId': string;
    'amount'?: Prices;
    /**
     * unique ID
     * @type {string}
     * @memberof Fare
     */
    'id': string;
    /**
     * pointer to first leg of fare (can be shared with other Fare)
     * @type {string}
     * @memberof Fare
     */
    'outbound': string;
    'multiTicketType': MultiTicketType;
    'corporateTravel'?: CorporateTravel;
    'fareScore': FlightsFareScore;
}


export interface FareBrand {
    'gdxFareBrand'?: GdxBrand;
    'amadeusFareBrand'?: AmadeusBrand;
    'navitaireNdcBrand'?: NavitaireNdcBrand;
    'travelportFareBrand'?: TravelportBrand;
    'sabreFareBrand'?: SabreBrand;
    'travelFusionFareBrand'?: TravelFusionBrand;
}
export interface FareDetailsV2 {
    'penaltiesInfo'?: PenaltiesInfo;
    'refundable'?: boolean;
    'paxPricings'?: Array<PassengerPricing>;
    'timestamp': number;
    'excludeINS'?: boolean;
    'restrictions'?: Array<AmenitiesAndUtasPerSlice>;
    'took'?: number;
    'id': string;
    'conversationId': string;
    'multiTicketType'?: MultiTicketType;
    'corporateTravel'?: CorporateTravel;
    'slices': Array<FareSliceDetailsV2>;
    'multiCity'?: boolean;
    'multiTicket': boolean;
    'fareScore'?: FareScore;
}


export interface FarePricing {
    'baseAmount': Prices;
    'additionalMargin'?: Prices;
    'lastTicketDate'?: string;
    'totalWithDiscount'?: Prices;
    'total': Prices;
    'taxAmount': Prices;
}
export interface FareScore {
    'isFastest': boolean;
    'isBestQuality': boolean;
    'isCheapest': boolean;
    'comfort': number;
    'isBest': boolean;
    'value': number;
}
export interface FareSegment {
    'penaltiesInfo': PenaltiesInfo;
    'ticketIndex'?: number;
    'outgoing': boolean;
    'brand'?: FareBrand;
    'carrierCabinClass'?: string;
    'code'?: string;
    'codes': { [key: string]: string; };
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof FareSegment
     */
    'validatingCarrierCode'?: string;
    'sliceIndex': number;
    'bookingCode'?: string;
    'privateFare'?: boolean;
    'connection'?: boolean;
    'isSelfTransferLayover': boolean;
    'availableSeats': number;
    'baggageInfo': BaggageInfo;
    'cabinClassName'?: string;
}
export interface FareSlice {
    'segments': Array<FareSegment>;
}
export interface FareSliceDetailsV2 {
    'fareShelf'?: SegmentShelf;
    'outgoing': boolean;
    'amenitiesUtas'?: AmenitiesAndUtasV2;
    'fareDetails': FareSlice;
    'sliceIndex': number;
}
export interface FareSliceFareShelf {
    'value': number;
}
/**
 * `highestScore` - The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * `amount` - the lowest amount this fare can be sold at. For WN flights, this field will be empty;the front end will be listing flights with empty amount fields at the bottom when filtered by price.
 * `next` - if exists, the corresponding `return` [[Trip]] possible
 * `example` - one instance of a [[Trip.ID]]/[[Fare.ID]] corresponding to this outbound.
 * @export
 * @interface FareSliceOutbound
 */
export interface FareSliceOutbound {
    'fareSlice': string;
    'highestScore': FlightsFareScore;
    'amount'?: Prices;
    /**
     * if exists, the corresponding `return` [[Trip]] possible
     * @type {Array<string>}
     * @memberof FareSliceOutbound
     */
    'next'?: Array<string>;
    'example': Example;
}
export interface Fee {
    'currency': string;
    'price': number;
}
/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export interface Flights {
    'shopId': ShopId;
    'fareSlices': { [key: string]: FlightsFareSlice; };
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
    'outbound': Array<SliceOutbound>;
    'fares': { [key: string]: Fare; };
    'trips': { [key: string]: Trip; };
    'slices': { [key: string]: Slice; };
}
/**
 * The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * @export
 * @interface FlightsFareScore
 */
export interface FlightsFareScore {
    'value': number;
}
export interface FlightsFareSegment {
    'availableSeats': number;
    'privateFare': boolean;
}
export interface FlightsFareSlice {
    'fareShelf': FareSliceFareShelf;
    'tags': Tags;
    'id': string;
    'slice': string;
    'segments': Array<FlightsFareSegment>;
    'fareBrandName': string;
}
export interface FreshFood {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * @type Funnel
 * @export
 */
export type Funnel = { Funnel: 'Air' } & Air | { Funnel: 'Ground' } & Ground | { Funnel: 'Home' } & Home | { Funnel: 'Lodging' } & Lodging;

export const FunnelEnum = {
    Air: 'Air',
    Ground: 'Ground',
    Home: 'Home',
    Lodging: 'Lodging'
} as const;

export type FunnelEnum = typeof FunnelEnum[keyof typeof FunnelEnum];


export interface GdxBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface GeopoliticalInfo {
    /**
     * 2 character country code
     * @type {string}
     * @memberof GeopoliticalInfo
     */
    'countryCode': string;
    'regionCode'?: string;
    'currency': string;
    'timeZone': string;
}
/**
 * Request a ChFAR offer (shopped product)
 * @export
 * @interface GetAirChfarOfferRequest
 */
export interface GetAirChfarOfferRequest {
    'tripId': string;
    'fareId': string;
}
/**
 * Request a ChFAR quote
 * @export
 * @interface GetAirChfarOfferRequestV1
 */
export interface GetAirChfarOfferRequestV1 {
    'tripId': string;
    'fareId': string;
}
/**
 * @type GetAirChfarOfferResponse
 * CHFAR quote response (shopped product) 
 * @export
 */
export type GetAirChfarOfferResponse = { GetAirChfarOfferResponse: 'Available' } & Available | { GetAirChfarOfferResponse: 'ChFarOfferNotFound' } & ChFarOfferNotFound | { GetAirChfarOfferResponse: 'InvalidOffer' } & InvalidOffer | { GetAirChfarOfferResponse: 'NotAvailable' } & NotAvailable | { GetAirChfarOfferResponse: 'ServerError' } & ServerError;

export const GetAirChfarOfferResponseEnum = {
    Available: 'Available',
    ChFarOfferNotFound: 'ChFarOfferNotFound',
    InvalidOffer: 'InvalidOffer',
    NotAvailable: 'NotAvailable',
    ServerError: 'ServerError'
} as const;

export type GetAirChfarOfferResponseEnum = typeof GetAirChfarOfferResponseEnum[keyof typeof GetAirChfarOfferResponseEnum];


/**
 * ChFAR quote response
 * @export
 * @interface GetAirChfarOfferResponseV1
 */
export interface GetAirChfarOfferResponseV1 {
    'offer'?: AirChfarOfferV1;
    'trackingProperties': TrackingProperties;
}
export interface Ground {
    'Funnel': FunnelEnum;
}


export interface Home {
    'Funnel': FunnelEnum;
}


export const HopperCabinClass = {
    Business: 'Business',
    Economy: 'Economy',
    First: 'First',
    PremiumEconomy: 'PremiumEconomy',
    Unknown: 'Unknown'
} as const;

export type HopperCabinClass = typeof HopperCabinClass[keyof typeof HopperCabinClass];


export interface Icon {
    'smallIconUrl': string;
    'largeIconUrl': string;
}
export interface Interval {
    'dates': string;
    'copy': string;
}
export interface Intervals {
    'normal'?: Interval;
    'warning'?: Interval;
    'danger'?: Interval;
}
export interface InvalidOffer {
    'offers': Array<AirChfarOffer>;
    'GetAirChfarOfferResponse': GetAirChfarOfferResponseEnum;
}


export interface IsEligible {
    'candidateId': string;
    'PriceDropProtection': PriceDropProtectionEnum;
    'trackingPropertiesV2': TrackingProperties;
    'maximumRefund': PriceDropMaximumRefund;
    'minimumRefund': PriceDropMinimumRefund;
    'monitoringDuration': PriceDropMonitoringDuration;
}


export interface Layout {
    'info': AmenityInfo;
}
export interface Lodging {
    'Funnel': FunnelEnum;
}


export interface Mass {
    'value': number;
    'unit': string;
}
export interface MultiPolicyV2 {
    'afterDeparture'?: PolicyV2;
    'anytime'?: PolicyV2;
    'beforeDeparture'?: PolicyV2;
}
export const MultiTicketType = {
    hackerFare: 'hackerFare',
    single: 'single',
    virtualInterline: 'virtualInterline'
} as const;

export type MultiTicketType = typeof MultiTicketType[keyof typeof MultiTicketType];


export interface NavitaireNdcBrand {
    'brandId'?: string;
    'brandName': string;
}
export interface NotAllowed {
    'BaggageInfo': BaggageInfoEnum;
}


export interface NotAvailable {
    'GetAirChfarOfferResponse': GetAirChfarOfferResponseEnum;
}


export interface NotEligible {
    'reason'?: string;
    'PriceDropProtection': PriceDropProtectionEnum;
}


export interface NotEnoughSeats {
    'AirChfarError': AirChfarErrorEnum;
}


export interface OfferNotFound {
    'AirChfarError': AirChfarErrorEnum;
}


export interface OfferWithSuggested {
    'offer': PriceFreezeOffer;
    'cheapestTrip': PriceFreezeCheapestTrip;
}
export interface OffersResponse {
    'bestOfferOverall'?: TravelWalletOffer;
    'offersByTripId': { [key: string]: TravelWalletOffer; };
}
export interface PassengerPricing {
    'paxType': string;
    'pricing': FarePricing;
    'quantity': number;
}
/**
 * @type PenaltiesInfo
 * @export
 */
export type PenaltiesInfo = { PenaltiesInfo: 'ExternallyManaged' } & PenaltiesInfoExternallyManaged | { PenaltiesInfo: 'Known' } & PenaltiesInfoKnown | { PenaltiesInfo: 'Unknown' } & PenaltiesInfoUnknown;

export const PenaltiesInfoEnum = {
    ExternallyManaged: 'ExternallyManaged',
    Known: 'Known',
    Unknown: 'Unknown'
} as const;

export type PenaltiesInfoEnum = typeof PenaltiesInfoEnum[keyof typeof PenaltiesInfoEnum];


export interface PenaltiesInfoExternallyManaged {
    'code': string;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoKnown {
    'changePenalty': Penalty;
    'cancelPenalty': Penalty;
    'PenaltiesInfo': PenaltiesInfoEnum;
}


export interface PenaltiesInfoUnknown {
    'PenaltiesInfo': PenaltiesInfoEnum;
}


/**
 * @type Penalty
 * @export
 */
export type Penalty = { Penalty: 'NoPenalty' } & PenaltyNoPenalty | { Penalty: 'NotPossible' } & PenaltyNotPossible | { Penalty: 'Unknown' } & PenaltyUnknown | { Penalty: 'WithFee' } & PenaltyWithFee;

export const PenaltyEnum = {
    NoPenalty: 'NoPenalty',
    NotPossible: 'NotPossible',
    Unknown: 'Unknown',
    WithFee: 'WithFee'
} as const;

export type PenaltyEnum = typeof PenaltyEnum[keyof typeof PenaltyEnum];


export interface PenaltyNoPenalty {
    'Penalty': PenaltyEnum;
}


export interface PenaltyNotPossible {
    'Penalty': PenaltyEnum;
}


export interface PenaltyUnknown {
    'Penalty': PenaltyEnum;
}


export interface PenaltyWithFee {
    'amount': number;
    'currency': string;
    'Penalty': PenaltyEnum;
}


/**
 * coveragePercentage values between 0 and 100
 * @export
 * @interface Percentage
 */
export interface Percentage {
    'value': number;
}
export const Platform = {
    Desktop: 'Desktop',
    Mobile: 'Mobile'
} as const;

export type Platform = typeof Platform[keyof typeof Platform];


export interface PolicyCompliance {
    'isInPolicy': boolean;
    'reasons': Array<string>;
}
export interface PolicyV2 {
    'headline': string;
    'description'?: string;
    'assessment': AssessmentV2;
    'fee'?: Fee;
}


export interface Power {
    'info': AmenityInfo;
    'exists': AmenityExists;
}


/**
 * `recommendation` - Deprecated. Use `recommendationV2`
 * @export
 * @interface Prediction
 */
export interface Prediction {
    'predictionCopy'?: PredictionCopy;
    'recommendation'?: Recommendation;
    'trackingProperties': TrackingProperties;
    'lowestPrice': Prices;
    'recommendationV2': RecommendationV2;
    'PredictionResult': PredictionResultEnum;
    'priceDropProtection': PriceDropProtection;
    'pricePrediction': PricePrediction;
    'dealness': Dealness;
}


export interface PredictionCopy {
    'recommendationBodyWatching': Array<string>;
    'carrier': string;
    'recommendationTitleWatching': Array<string>;
    'intervals': Intervals;
    'recommendationBody': Array<string>;
    'lowestPriceLabel': string;
    'recommendationTitleJustWatched': Array<string>;
    'lowestPrice': string;
    'recommendationBodyJustWatched': Array<string>;
    'travelDates': string;
    'origin': string;
    'recommendationTitle': Array<string>;
    'dealness': string;
    'destination': string;
}
/**
 * @type PredictionResult
 * @export
 */
export type PredictionResult = { PredictionResult: 'Prediction' } & Prediction | { PredictionResult: 'UnavailablePrediction' } & UnavailablePrediction;

export const PredictionResultEnum = {
    Prediction: 'Prediction',
    UnavailablePrediction: 'UnavailablePrediction'
} as const;

export type PredictionResultEnum = typeof PredictionResultEnum[keyof typeof PredictionResultEnum];


export interface PriceDropMaximumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMinimumRefund {
    'display': string;
    'amount': Amount;
}
export interface PriceDropMonitoringDuration {
    'inSeconds': number;
}
/**
 * @type PriceDropProtection
 * @export
 */
export type PriceDropProtection = { PriceDropProtection: 'IsEligible' } & IsEligible | { PriceDropProtection: 'NotEligible' } & NotEligible;

export const PriceDropProtectionEnum = {
    IsEligible: 'IsEligible',
    NotEligible: 'NotEligible'
} as const;

export type PriceDropProtectionEnum = typeof PriceDropProtectionEnum[keyof typeof PriceDropProtectionEnum];


/**
 * `isCheapest` - Is the offer related to the cheapest trip
 * @export
 * @interface PriceFreezeCheapestTrip
 */
export interface PriceFreezeCheapestTrip {
    'tripId': string;
    'fareId': string;
    /**
     * Is the offer related to the cheapest trip
     * @type {boolean}
     * @memberof PriceFreezeCheapestTrip
     */
    'isCheapest': boolean;
}
export interface PriceFreezeOffer {
    'seatedPassengers': { [key: string]: number; };
    'voidWindowAvailabilityEnd': VoidWindowAvailabilityEnd;
    'passengers': { [key: string]: number; };
    'totalAmount': Prices;
    'id': string;
    'timeToLive': PriceFreezeOfferTimeToLive;
    'perPaxAmount': Prices;
    'cap': PriceFreezeOfferCap;
}
export interface PriceFreezeOfferCap {
    'value': Amount;
}
export interface PriceFreezeOfferTimeToLive {
    'inSeconds': number;
    'inHours'?: number;
    'inDays'?: number;
}
export interface PricePrediction {
    'minPrice'?: DisplayAmount;
    'maxPrice'?: DisplayAmount;
}
/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
export interface ProductNotFound {
    'AirChfarError': AirChfarErrorEnum;
}


export const QuoteDecision = {
    quoteDecisionFallback: 'quoteDecisionFallback',
    quoteDecisionRequested: 'quoteDecisionRequested',
    quoteDecisionUnspecified: 'quoteDecisionUnspecified'
} as const;

export type QuoteDecision = typeof QuoteDecision[keyof typeof QuoteDecision];


/**
 * Deprecated. Use `recommendationV2`
 * @export
 * @enum {string}
 */

export const Recommendation = {
    Buy: 'Buy',
    Wait: 'Wait'
} as const;

export type Recommendation = typeof Recommendation[keyof typeof Recommendation];


export const RecommendationV2 = {
    Buy: 'Buy',
    BuyNeutral: 'BuyNeutral',
    Wait: 'Wait',
    WaitNeutral: 'WaitNeutral'
} as const;

export type RecommendationV2 = typeof RecommendationV2[keyof typeof RecommendationV2];


export const RegionType = {
    airport: 'airport',
    city: 'city'
} as const;

export type RegionType = typeof RegionType[keyof typeof RegionType];


/**
 * A description of a route's origin and destination
 * @export
 * @interface Route
 */
export interface Route {
    'origin': AirportRegion;
    'destination': AirportRegion;
}
export interface SabreBrand {
    'brandId': string;
    'brandName'?: string;
}
export interface Seat {
    'flatness': SeatFlatness;
    'info': AmenityInfo;
    'pitch': string;
    'legroom': SeatLegroom;
    'width': SeatWidth;
}


export const SeatFlatness = {
    angle_flat: 'angle_flat',
    full_flat: 'full_flat',
    na: 'na',
    not_flat: 'not_flat'
} as const;

export type SeatFlatness = typeof SeatFlatness[keyof typeof SeatFlatness];


export const SeatLegroom = {
    less: 'less',
    more: 'more',
    na: 'na',
    standard: 'standard'
} as const;

export type SeatLegroom = typeof SeatLegroom[keyof typeof SeatLegroom];


export const SeatWidth = {
    na: 'na',
    standard: 'standard',
    wider: 'wider'
} as const;

export type SeatWidth = typeof SeatWidth[keyof typeof SeatWidth];


export interface Segment {
    'plusDays': number;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Segment
     */
    'marketingAirline': string;
    'stopoverDurationMinutes'?: number;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Segment
     */
    'origin': string;
    'departure': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Segment
     */
    'operatingAirline': string;
    'flightNumber': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Segment
     */
    'destination': string;
    'arrival': string;
}
export interface SegmentShelf {
    'rating': number;
    'brandName': string;
    'shortBrandName': string;
    'opaqueMapperStep'?: string;
}
export interface ServerError {
    'GetAirChfarOfferResponse': GetAirChfarOfferResponseEnum;
}


export const ShopFilter = {
    NoFilter: 'NoFilter',
    NoLCC: 'NoLCC',
    NonStop: 'NonStop',
    NonStopNoLCC: 'NonStopNoLCC',
    ShortLayover: 'ShortLayover',
    ShortLayoverNoLCC: 'ShortLayoverNoLCC'
} as const;

export type ShopFilter = typeof ShopFilter[keyof typeof ShopFilter];


export interface ShopId {
    'value': string;
}
export interface ShopSummaryAirline {
    'code': string;
    'name': string;
}
export interface ShopSummaryRequest {
    'originLocationLabel'?: string;
    'passengers': { [key: string]: number; };
    'destinationLocationLabel'?: string;
    'fareClass'?: Array<string>;
    'returnDate'?: string;
    'route': Route;
    'tripFilter': ShopFilter;
    'platform': Platform;
    'departureDate': string;
}


export interface ShopSummaryResponseV2 {
    'flights': Flights;
    'prediction'?: PredictionResult;
    'priceFreezeOffer'?: OfferWithSuggested;
    'offers'?: OffersResponse;
}
export interface SingleFlightItineraryRequest {
    'itineraryId': string;
    'referenceDateTime': string;
}
export interface SingleFlightItineraryResponse {
    'itinerary': AirChfarExerciseSharedModelsOpaqueValue;
    'context': TripContext;
}
/**
 * `hasSelfTransferLayover` - if true, the user must transfer between airlines/gates/airports in order to reach their next flight on the following segment
 * `highestScore` - deprecate. this is not actually accurate since the same `return` slice on multiple slices can have different `FareScore` depending on the `outbound` slice selected.
 * @export
 * @interface Slice
 */
export interface Slice {
    'domestic': boolean;
    /**
     * if true, the user must transfer between airlines/gates/airports in order to reach their next flight on the following segment
     * @type {boolean}
     * @memberof Slice
     */
    'hasSelfTransferLayover': boolean;
    'highestScore': FlightsFareScore;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof Slice
     */
    'marketingAirline': string;
    'lowestPrice'?: number;
    'id': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Slice
     */
    'origin': string;
    'totalDurationMinutes': number;
    'segments': Array<Segment>;
    'departure': string;
    /**
     * 3 character IATA Airport code
     * @type {string}
     * @memberof Slice
     */
    'destination': string;
    'arrival': string;
    'stops': number;
}
/**
 * `highestScore` - The highest possible `FareScore` associated with a flight with this outbound `FareSlice`
 * @export
 * @interface SliceOutbound
 */
export interface SliceOutbound {
    'latestReturnArrival'?: string;
    'earliestReturnArrival'?: string;
    'highestScore': FlightsFareScore;
    'slice': string;
    'fares': Array<FareSliceOutbound>;
    'latestReturnDeparture'?: string;
    'earliestReturnDeparture'?: string;
}
export interface Success {
    'value'?: TripDetailsV2;
    'AirChfarTripDetailsResponse': AirChfarTripDetailsResponseEnum;
}


export interface Tags {
    'isBest': boolean;
    'isCheapest': boolean;
    'isBestQuality': boolean;
    'isFastest': boolean;
}
export interface TrackingProperties {
    'properties'?: any;
    'encryptedProperties'?: string;
}
export interface TravelFusionBrand {
    'brandId': string;
    'brandName'?: string;
}
/**
 * `percentage` - Percentage discount amount for percentage offer
 * `amount` - Discount amount in USD
 * `imageFolderUrl` - URL to the folder with offer images.
 * `imageId` - Image name that's set in the offer config
 * `maxDiscountAmount` - Max discount amount in USD for percentage offer
 * @export
 * @interface TravelWalletOffer
 */
export interface TravelWalletOffer {
    /**
     * Percentage discount amount for percentage offer
     * @type {number}
     * @memberof TravelWalletOffer
     */
    'percentage'?: number;
    'shopPageBanner'?: string;
    'funnels': Array<Funnel>;
    'amount': Amount;
    /**
     * URL to the folder with offer images.
     * @type {string}
     * @memberof TravelWalletOffer
     */
    'imageFolderUrl'?: string;
    'expiresOn': string;
    'availabilityPageBanner'?: string;
    'id': string;
    /**
     * Image name that's set in the offer config
     * @type {string}
     * @memberof TravelWalletOffer
     */
    'imageId'?: string;
    'trackingPropertiesV2': TrackingProperties;
    'termsAndConditions'?: string;
    'title': string;
    'landingPageBanner'?: string;
    'maxDiscountAmount'?: Amount;
    'descriptions': Array<string>;
}
export interface TravelportBrand {
    'brandId': string;
    'brandName'?: string;
    'brandTier'?: number;
}
export interface Trip {
    'id': string;
    'outbound': string;
    'return'?: string;
    'fares': Array<string>;
}
export interface TripContext {
    'airports': { [key: string]: Airport; };
    'airlines': { [key: string]: Airline; };
}
/**
 * `airports` - Airports for each destination and origin in each SegmentDetails of the TripSlices
 * `airlines` - Airlines in each SegmentDetails of the TripSlices
 * @export
 * @interface TripDetailsV2
 */
export interface TripDetailsV2 {
    /**
     * Airports for each destination and origin in each SegmentDetails of the TripSlices
     * @type {Array<Airport>}
     * @memberof TripDetailsV2
     */
    'airports': Array<Airport>;
    /**
     * Airlines in each SegmentDetails of the TripSlices
     * @type {Array<Airline>}
     * @memberof TripDetailsV2
     */
    'airlines': Array<Airline>;
    'pointOfSaleCountryCode': string;
    'fareDetails': Array<FareDetailsV2>;
    'id': string;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof TripDetailsV2
     */
    'validatingCarrierCode'?: string;
    'tripDescription': string;
    'slices': Array<TripSlice>;
}
export interface TripId {
    'value': string;
}
/**
 * `codeSharedCarrier` - Additional text about codeshare or marketing arrangement, e.g. 'Republic Airways As American Eagle.'
 * `isSelfTransferLayover` - if true, the user must transfer their baggage from the flight before boarding the next because the segments are virtually interlined. None if there happens to be fares that are both self transfers and regular transfers, case unexpected.
 * `stops` - These are refueling stops. It's not indicative of layovers
 * @export
 * @interface TripSegment
 */
export interface TripSegment {
    'departureTime': string;
    'airlineName': string;
    'airlineCode': string;
    'zonedDepartureTime': string;
    'zonedArrivalTime': string;
    'plusDays': number;
    'marketingAirline': ShopSummaryAirline;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'originName': string;
    'stopoverDurationMinutes'?: number;
    /**
     * Additional text about codeshare or marketing arrangement, e.g. 'Republic Airways As American Eagle.'
     * @type {string}
     * @memberof TripSegment
     */
    'codeSharedCarrier'?: string;
    'operatingAirline': ShopSummaryAirline;
    /**
     * if true, the user must transfer their baggage from the flight before boarding the next because the segments are virtually interlined. None if there happens to be fares that are both self transfers and regular transfers, case unexpected.
     * @type {boolean}
     * @memberof TripSegment
     */
    'isSelfTransferLayover'?: boolean;
    'flightNumber': string;
    'destinationCode': string;
    /**
     * These are refueling stops. It's not indicative of layovers
     * @type {number}
     * @memberof TripSegment
     */
    'stops': number;
}
export interface TripSlice {
    'departureTime': string;
    'zonedDepartureTime': string;
    'outgoing': boolean;
    'arrivalTime': string;
    'destinationName': string;
    'originCode': string;
    'id': string;
    'segmentDetails': Array<TripSegment>;
    'originName': string;
    'totalDurationMinutes': number;
    'destinationCode': string;
    'stops': number;
}
/**
 * When a flight cannot be currently voided
 * @export
 * @interface Unavailable
 */
export interface Unavailable {
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface UnavailablePrediction {
    'reason': string;
    'PredictionResult': PredictionResultEnum;
}


export interface Unknown {
    'BaggageInfo': BaggageInfoEnum;
}


/**
 * When a flight currently has a void window, with information about when it ends
 * @export
 * @interface Until
 */
export interface Until {
    'time': string;
    'VoidWindowAvailabilityEnd': VoidWindowAvailabilityEndEnum;
}


export interface Upa {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'cta'?: Cta;
    'category': UpaCategory;
}


export const UpaCategory = {
    brand: 'brand',
    promotion: 'promotion',
    promotion_position1: 'promotion-position1',
    unrecognized: 'unrecognized'
} as const;

export type UpaCategory = typeof UpaCategory[keyof typeof UpaCategory];


export interface Uta {
    'headline': string;
    'description': string;
    'icon'?: Icon;
    'bagLimits': BagLimits;
    'cta'?: Cta;
    'category': UtaCategory;
    'assessment': UtaAssessment;
}


export const UtaAssessment = {
    benefit: 'benefit',
    fee: 'fee',
    neutral: 'neutral',
    restriction: 'restriction'
} as const;

export type UtaAssessment = typeof UtaAssessment[keyof typeof UtaAssessment];


export const UtaCategory = {
    advance_change: 'advance-change',
    boarding_priority: 'boarding-priority',
    cancellation: 'cancellation',
    carry_on_allowance: 'carry-on-allowance',
    check_in_priority: 'check-in-priority',
    checked_bag_allowance: 'checked-bag-allowance',
    lounge_access: 'lounge-access',
    personal_item: 'personal-item',
    refundable_fare: 'refundable-fare',
    same_day_change: 'same-day-change',
    seat_selection: 'seat-selection',
    upgrade_eligibility: 'upgrade-eligibility'
} as const;

export type UtaCategory = typeof UtaCategory[keyof typeof UtaCategory];


export interface UtasV2 {
    'fare'?: AmenitiesFare;
    'utas': Array<Uta>;
    'changePolicy'?: MultiPolicyV2;
    'cancellationPolicy'?: MultiPolicyV2;
}
/**
 * @type VoidWindowAvailabilityEnd
 * Information about availability of a void window for a flight (=cancellable)
 * @export
 */
export type VoidWindowAvailabilityEnd = { VoidWindowAvailabilityEnd: 'Unavailable' } & Unavailable | { VoidWindowAvailabilityEnd: 'Until' } & Until;

export const VoidWindowAvailabilityEndEnum = {
    Unavailable: 'Unavailable',
    Until: 'Until'
} as const;

export type VoidWindowAvailabilityEndEnum = typeof VoidWindowAvailabilityEndEnum[keyof typeof VoidWindowAvailabilityEndEnum];


export interface WebLinks {
    'changeCancelPolicy'?: string;
    'otherFee'?: string;
    'checkInPolicy'?: string;
    'wifiFee'?: string;
    'homePage'?: string;
    'baggageFees'?: string;
    'seatUpgrade'?: string;
    'manageBooking'?: string;
    'seatSelection'?: string;
}
export interface Wifi {
    'info': AmenityInfo;
    'exists': AmenityExists;
}



/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequest} getAirChfarOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirOfferGetPost: async (getAirChfarOfferRequest: GetAirChfarOfferRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAirChfarOfferRequest' is not null or undefined
            assertParamExists('apiV0ChfarAirOfferGetPost', 'getAirChfarOfferRequest', getAirChfarOfferRequest)
            const localVarPath = `/api/v0/chfar/air/offer/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAirChfarOfferRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rebook Shop
         * @param {AirChfarShopRequest} airChfarShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirShopPost: async (airChfarShopRequest: AirChfarShopRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'airChfarShopRequest' is not null or undefined
            assertParamExists('apiV0ChfarAirShopPost', 'airChfarShopRequest', airChfarShopRequest)
            const localVarPath = `/api/v0/chfar/air/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(airChfarShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rebook Trip Details
         * @param {AirChfarTripDetailsRequest} airChfarTripDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirTripDetailsPost: async (airChfarTripDetailsRequest: AirChfarTripDetailsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'airChfarTripDetailsRequest' is not null or undefined
            assertParamExists('apiV0ChfarAirTripDetailsPost', 'airChfarTripDetailsRequest', airChfarTripDetailsRequest)
            const localVarPath = `/api/v0/chfar/air/tripDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(airChfarTripDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exercise Quote (V1)
         * @param {AirChfarExerciseQuoteRequest} airChfarExerciseQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirExerciseQuotePost: async (airChfarExerciseQuoteRequest: AirChfarExerciseQuoteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'airChfarExerciseQuoteRequest' is not null or undefined
            assertParamExists('apiV1ChfarAirExerciseQuotePost', 'airChfarExerciseQuoteRequest', airChfarExerciseQuoteRequest)
            const localVarPath = `/api/v1/chfar/air/exercise/quote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(airChfarExerciseQuoteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Rebook Shop (V1)
         * @param {AirChfarExerciseShopRequest} airChfarExerciseShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirExerciseShopPost: async (airChfarExerciseShopRequest: AirChfarExerciseShopRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'airChfarExerciseShopRequest' is not null or undefined
            assertParamExists('apiV1ChfarAirExerciseShopPost', 'airChfarExerciseShopRequest', airChfarExerciseShopRequest)
            const localVarPath = `/api/v1/chfar/air/exercise/shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(airChfarExerciseShopRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequestV1} getAirChfarOfferRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirOfferGetPost: async (getAirChfarOfferRequestV1: GetAirChfarOfferRequestV1, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getAirChfarOfferRequestV1' is not null or undefined
            assertParamExists('apiV1ChfarAirOfferGetPost', 'getAirChfarOfferRequestV1', getAirChfarOfferRequestV1)
            const localVarPath = `/api/v1/chfar/air/offer/get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getAirChfarOfferRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequest} getAirChfarOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest: GetAirChfarOfferRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAirChfarOfferResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChfarAirOfferGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rebook Shop
         * @param {AirChfarShopRequest} airChfarShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChfarAirShopPost(airChfarShopRequest: AirChfarShopRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirChfarShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChfarAirShopPost(airChfarShopRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChfarAirShopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rebook Trip Details
         * @param {AirChfarTripDetailsRequest} airChfarTripDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest: AirChfarTripDetailsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirChfarTripDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV0ChfarAirTripDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Exercise Quote (V1)
         * @param {AirChfarExerciseQuoteRequest} airChfarExerciseQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest: AirChfarExerciseQuoteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirChfarExerciseQuoteResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1ChfarAirExerciseQuotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Rebook Shop (V1)
         * @param {AirChfarExerciseShopRequest} airChfarExerciseShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest: AirChfarExerciseShopRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AirChfarExerciseShopResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1ChfarAirExerciseShopPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequestV1} getAirChfarOfferRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1: GetAirChfarOfferRequestV1, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAirChfarOfferResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DefaultApi.apiV1ChfarAirOfferGetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequest} getAirChfarOfferRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest: GetAirChfarOfferRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAirChfarOfferResponse> {
            return localVarFp.apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rebook Shop
         * @param {AirChfarShopRequest} airChfarShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirShopPost(airChfarShopRequest: AirChfarShopRequest, options?: RawAxiosRequestConfig): AxiosPromise<AirChfarShopResponse> {
            return localVarFp.apiV0ChfarAirShopPost(airChfarShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rebook Trip Details
         * @param {AirChfarTripDetailsRequest} airChfarTripDetailsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest: AirChfarTripDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<AirChfarTripDetailsResponse> {
            return localVarFp.apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Exercise Quote (V1)
         * @param {AirChfarExerciseQuoteRequest} airChfarExerciseQuoteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest: AirChfarExerciseQuoteRequest, options?: RawAxiosRequestConfig): AxiosPromise<AirChfarExerciseQuoteResponse> {
            return localVarFp.apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Rebook Shop (V1)
         * @param {AirChfarExerciseShopRequest} airChfarExerciseShopRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest: AirChfarExerciseShopRequest, options?: RawAxiosRequestConfig): AxiosPromise<AirChfarExerciseShopResponse> {
            return localVarFp.apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get Air ChFAR Offer
         * @param {GetAirChfarOfferRequestV1} getAirChfarOfferRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1: GetAirChfarOfferRequestV1, options?: RawAxiosRequestConfig): AxiosPromise<GetAirChfarOfferResponseV1> {
            return localVarFp.apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get Air ChFAR Offer
     * @param {GetAirChfarOfferRequest} getAirChfarOfferRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest: GetAirChfarOfferRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChfarAirOfferGetPost(getAirChfarOfferRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rebook Shop
     * @param {AirChfarShopRequest} airChfarShopRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChfarAirShopPost(airChfarShopRequest: AirChfarShopRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChfarAirShopPost(airChfarShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rebook Trip Details
     * @param {AirChfarTripDetailsRequest} airChfarTripDetailsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest: AirChfarTripDetailsRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0ChfarAirTripDetailsPost(airChfarTripDetailsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exercise Quote (V1)
     * @param {AirChfarExerciseQuoteRequest} airChfarExerciseQuoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest: AirChfarExerciseQuoteRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1ChfarAirExerciseQuotePost(airChfarExerciseQuoteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Rebook Shop (V1)
     * @param {AirChfarExerciseShopRequest} airChfarExerciseShopRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest: AirChfarExerciseShopRequest, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1ChfarAirExerciseShopPost(airChfarExerciseShopRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get Air ChFAR Offer
     * @param {GetAirChfarOfferRequestV1} getAirChfarOfferRequestV1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1: GetAirChfarOfferRequestV1, options?: RawAxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV1ChfarAirOfferGetPost(getAirChfarOfferRequestV1, options).then((request) => request(this.axios, this.basePath));
    }
}



